import React from 'react';

const Confidentialite = ({ onBack }) => {
  const sections = [
    {
      num: '1.',
      title: 'Nature des données collectées',
      body: "Dans le cadre de l'amélioration continue de nos services, ComptaAI collecte des statistiques d'utilisation strictement anonymes et agrégées : pages consultées, fonctionnalités utilisées, erreurs techniques rencontrées et sessions anonymes."
    },
    {
      num: '2.',
      title: 'Aucune donnée personnelle collectée',
      body: "Ces statistiques ne permettent en aucun cas d'identifier une personne. Aucune adresse IP, aucune adresse e-mail, aucun nom, aucune donnée comptable ou financière n'est collectée ou stockée dans le cadre de ce suivi. Aucun cookie de traçage n'est utilisé à cette fin."
    },
    {
      num: '3.',
      title: 'Base légale',
      body: "Ce traitement repose sur notre intérêt légitime (article 6.1.f du Règlement Général sur la Protection des Données - RGPD) d'améliorer la qualité, la sécurité et l'expérience de nos services."
    },
    {
      num: '4.',
      title: 'Durée de conservation',
      body: "Les statistiques d'usage sont conservées pour une durée maximale de 90 jours, puis automatiquement et définitivement supprimées."
    },
    {
      num: '5.',
      title: 'Vos droits',
      body: "Conformément au RGPD, vous disposez d'un droit d'accès, de rectification et d'opposition sur les données vous concernant. Pour toute question relative à vos données, contactez-nous à contact@compta-ia-app.fr."
    }
  ];

  return (
    <div style={{
      minHeight: '100vh', background: '#F5F4ED', fontFamily: 'Inter, system-ui, sans-serif',
      display: 'flex', flexDirection: 'column'
    }}>
      <header style={{
        background: 'rgba(248, 250, 252, 0.8)', backdropFilter: 'blur(12px)',
        borderBottom: '1px solid #E2E8F0', padding: '16px 40px',
        display: 'flex', alignItems: 'center', justifyContent: 'space-between'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <div style={{
            width: '36px', height: '36px', borderRadius: '10px',
            background: 'linear-gradient(135deg, #1D9E75, #10B981)',
            color: 'white', fontSize: '18px', fontWeight: 'bold',
            display: 'flex', alignItems: 'center', justifyContent: 'center'
          }}>
            C
          </div>
          <span style={{ fontSize: '20px', fontWeight: '700', letterSpacing: '-0.5px', color: '#0F172A' }}>ComptaAI</span>
        </div>
        <button
          onClick={onBack}
          style={{
            padding: '10px 18px', background: 'none', border: '1px solid #CBD5E1',
            borderRadius: '10px', color: '#475569', fontSize: '14px', fontWeight: '600',
            cursor: 'pointer', transition: 'all 0.2s'
          }}
          onMouseEnter={(e) => { e.target.style.borderColor = '#1D9E75'; e.target.style.color = '#1D9E75'; }}
          onMouseLeave={(e) => { e.target.style.borderColor = '#CBD5E1'; e.target.style.color = '#475569'; }}
        >
          ← Retour à l'accueil
        </button>
      </header>

      <main style={{ flex: 1, padding: '48px 24px', display: 'flex', justifyContent: 'center' }}>
        <div style={{
          background: 'white', borderRadius: '16px', boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
          padding: '48px 56px', maxWidth: '800px', width: '100%'
        }}>
          <h1 style={{ fontSize: '28px', fontWeight: '700', color: '#0F172A', margin: '0 0 8px 0' }}>
            Politique de confidentialité
          </h1>
          <p style={{ fontSize: '14px', color: '#73726C', margin: '0 0 8px 0' }}>
            Dernière mise à jour : août 2026
          </p>
          <p style={{ fontSize: '15px', lineHeight: '1.7', color: '#334155', margin: '0 0 32px 0' }}>
            ComptaAI s'engage à protéger les données de ses utilisateurs et à respecter le Règlement Général sur la Protection des Données (RGPD — Règlement (UE) 2016/679).
          </p>

          {sections.map((s) => (
            <div key={s.num} style={{ marginBottom: '28px' }}>
              <h2 style={{ fontSize: '17px', fontWeight: '600', color: '#1F2937', margin: '0 0 8px 0' }}>
                {s.num} {s.title}
              </h2>
              <p style={{ fontSize: '15px', lineHeight: '1.7', color: '#334155', margin: 0 }}>
                {s.body}
              </p>
            </div>
          ))}

          <div style={{
            marginTop: '32px', padding: '16px 20px', background: '#F0FDF4',
            border: '1px solid #BBF7D0', borderRadius: '12px', fontSize: '14px', color: '#166534', lineHeight: '1.6'
          }}>
            Votre confiance est notre priorité : les statistiques d'utilisation sont anonymes, n'identifient jamais une personne et ne contiennent aucune donnée comptable.
          </div>
        </div>
      </main>
    </div>
  );
};

export default Confidentialite;
